
import { environment } from '../environments/environment';


// export const base_url = 'https://prodapi.aed365.com/aed365-backend-phpadminapi/public/api/';
export const base_url = environment.base_url;
//export const base_url = environment.base_url;

//export const base_url = 'http://dev.algoworks.com/aed365-backend-phpadminapi/public/api/';
//export const base_url = 'http://192.168.9.29/aed365-backend-adminpanelapi/public/api/';

export const changePassword = base_url + 'profile/change-password';
export const updateProfile = base_url + 'profile/update';
export const getProfile = base_url + 'profile/me';
export const getOdo = base_url + '/user/odo';
export const getMakeList = base_url + '/user/getCarModelAndMake';
export const carPreference = base_url + '/user/car_preferences';
export const getCities = base_url + '/user/getCities';
export const googleLocationKey = environment.googleLocationKey;
export const googleLocationUrl = 'https://maps.googleapis.com/maps/api/geocode/json';

export const urls: any={
	equipmentDependency: base_url + 'equipment/dependency',
	equipmentList: base_url + 'equipment/list',
	viewEquipment: base_url + 'equipment/view',
	addEquipment: base_url + 'equipment/add',
	updateEquipment: base_url + 'equipment/update',
	deleteEquipment: base_url + 'equipment/delete',
	equipmentBulkUpload: base_url + 'equipment/bulk-upload',
	equipmentBulkUploadTemplate: base_url + 'equipment/bulk-upload-template',
	equipmentTypesList: base_url + 'equipment/types/list',
	addEquipmentType: base_url + 'equipment/types/add',
	updateEquipmentType: base_url + 'equipment/types/update',
	deleteEquipmentType: base_url + 'equipment/types/delete',
	addAedDependency: base_url + 'aed/add-aed-dependency',
	aedList: base_url + 'aed/list',
	viewAed: base_url + 'aed/view',
	oldAedParts: base_url + 'aed/parts/old/list',
	deleteAed: base_url + 'aed/delete',
	addAed: base_url + 'v3/aed/add',
	updateAed: base_url + 'v3/aed/update',
	trashList: base_url +'aed/trash/list',
	userRestoreList: base_url +'user/trash/list',
	subscriptionList: base_url +'subscription/list',
	addDependency: base_url +'subscription/add-dependency',
	addSubscription: base_url +'subscription/add',
	bulkAssignSubscription: base_url +'subscription/bulk-assign',
	deleteSubscription: base_url +'subscription/delete',
	getSitesByCompany: base_url +'site/list-by-company',
	viewSubscription: base_url +'subscription/view',
	addLibrary: base_url +'library/edit',
	assignLibraryToAll: base_url +'library/assign-to-all',
	generaterx: base_url +'aed/generate-rx',
	aedRx: base_url +'aed/rx',
	responderAdd:base_url + 'responder/add',
	responderList: base_url + 'responder/list',
	userList: base_url + 'user/list',
	userListWithoutSites: base_url + 'user/list-without-sites',
	userListWithoutCompanies: base_url + 'user/list-without-companies',
	userListInactive: base_url + 'user/list-inactive',
	siteList:base_url + 'site/list',
	aedDeactivate: base_url + 'aed/deactivate',
	aedReactivate: base_url + 'aed/reactivate',
	aedPermanentDelete: base_url + 'aed/trash/permanent-delete',
	siteDeactivate: base_url + 'site/deactivate',
	siteReactivate: base_url + 'site/reactivate',
	sitePsapSites: base_url + 'site/psap-sites',
	siteCopyPsap: base_url + 'site/copy-psap',
	siteContactAdd: base_url + 'site/contact/add',
	siteContactUpdate: base_url + 'site/contact/update',
	siteContactDelete: base_url + 'site/contact/delete',
	siteContactCompanyUsers: base_url + 'site/contact/company-users',
	siteContactDetachUser: base_url + 'site/contact/detach-user',
	siteContactCreateUser: base_url + 'site/contact/create-user',
	masterUserRoleList: base_url + 'master/user-role/list',
	certificationProvider: base_url + 'responder/dependency',
	viewResponder:base_url + 'responder/fetch/{responder_id}',
	deleteResponder: base_url + 'responder/delete/{responder_id}',
	editResponder:base_url + 'responder/update',
	companyList:base_url + 'company/list',
	AEDRequestsList: base_url+ 'aed/custom/list',
	viewCustomAED: base_url + 'aed/custom/view',
	acceptCustomAED: base_url + 'aed/custom/accept',
	rejectCustomAED: base_url + 'aed/custom/reject',
	verifyAdminUser: base_url + 'admin/authenticate',
	userManualList: base_url +'user_manual/list',
	userManualView: base_url +'user_manual/view',
	getUserManualById: base_url +'user_manual/get-user-manual-aed',
	addAedInspectorDependency: base_url + 'aed/add-aed-inspector-dependency',
	accessoryReplacementRequestList :base_url + 'aed/replacement/list',
	accessoryReplacementRequestView :base_url + 'aed/replacement/view',
	accessoryReplacementComplete: base_url + 'aed/accessory-update-status',
	getResellerlist: base_url+'reseller/list',
	getAEDlist: base_url+'reseller/get-aeds',
	getPlanslist: base_url+'reseller-subscription/list',
	addReseller: base_url+'reseller/add',
	editReseller: base_url + 'reseller/edit',
	getResellerData: base_url+'reseller/view',
	updateStatusReseller: base_url+'reseller/update-status',
	supportUsers:base_url+'admin/support-list',
	getResellerPermissions: base_url+'reseller/get-permissions',
	savePermissions:base_url +'reseller/save-permissions',
	authenticateReseller:base_url+'admin/authenticate-reseller',
	authenticateSupportUser:base_url+'admin/authenticate-support-user',
	authenticateUser:base_url+'admin/authenticate-user',
	getSupportUsersList: base_url+'reseller-support/list',
	getCompanies:base_url+'reseller-support/get-company',
	addSupportUser:base_url+'reseller-support/add',
	editSupportUser:base_url+'reseller-support/edit',
	viewSupportUser: base_url+'reseller-support/view',
	deleteSupportUser:base_url+'reseller-support/delete',
	resellerDashboard: base_url + 'dashboard/counts',
	mapView: base_url + 'dashboard/map-list',
	resellersList:base_url + 'reseller/get',
	getPurchasedList:base_url+ 'reseller-subscription/purchased-list',
	getSubscriptionRequestList:base_url+'reseller-subscription/request-list',
	updateRequest:base_url+'reseller-subscription/update-request',
	editAedsSubscription:base_url +'reseller-subscription/edit-aed',
	viewAedQr:base_url + 'aed/view-qrcode',
	renewSubscription:base_url +'reseller-subscription/renew',
	partsExpiredList: base_url +'aed/parts/list',
	viewPartExpired: base_url + 'aed/parts/detail',
	updatePartExpiredStatus: base_url + 'aed/parts/update-part-expired-status',
	incidentList: base_url + 'incidents/list',
	viewIncident: base_url + 'incidents/detail',
	updateIncident: base_url + 'incidents/update',
	deleteIncident: base_url + 'incidents/delete',
	bulkInspectionList: base_url + 'aed/bulk-inspection/list',
	bulkInspectionSave: base_url + 'aed/bulk-inspection/save',
	subscriptionReports: base_url + 'reseller-subscription/report',
	reminderReports: base_url + 'aed/heartsine-reminder-report',
	restoreAed: base_url+ 'aed/trash/restore',
	restoreUser: base_url+ 'user/trash/restore',
	manageSubscriptionList: base_url+ 'reseller-subscription/master-list',
	addPlan: base_url+  `reseller-subscription/add`,
	getSubscriptionDetails: base_url + `reseller-subscription/get`,
	getSubscriptionPdf: base_url + `reseller-subscription/invoice`,
	inspectionList: base_url + 'inspection/list',
	viewInspection: base_url + 'inspection/detail',
	lastVisitCount: base_url + 'last-visit/count',
	AEDTypeList: base_url + 'rms/aed-types',
	activateRMS: base_url + 'rms/activate-rms',
	downloadRMSReport: base_url + 'rms/reports',
	manageRenewReportList: base_url + 'subscription/renew-list',
	manageRenewReportDetail: base_url + 'subscription/renew-detail',
	updateRenewReportStatus: base_url + 'subscription/renew-update-status',
	downloadSampleFile: base_url + 'aed/sample-file',
	uploadBulkFile: base_url + 'aed/bulk-upload',
	cancelSubscription: base_url + 'reseller-subscription/cancel-plan',
	imageLibrary: base_url + 'aed/fetch-model-image',
	downloadOutofServiceAedList: base_url + 'aed/out-of-service',
	activateZoll:base_url + 'zoll/activate',
	deactivateZoll:base_url + 'zoll/deactivate',
	downloadZollReport:base_url + 'zoll/reports',
	getApiLogs: base_url + 'api-logs',
	getBatteryHistory: base_url + 'battery-history',
	getParts: base_url + 'master/model/get-parts',
	getInspectorList: base_url + 'global-inspector/get-inspectors',
	resetPasswordLink: base_url + 'user/generate-reset-link',
	getAedsBySerialNumbers: base_url + 'aed/get-by-serial-numbers',
	bulkUpdateAeds: base_url + 'aed/bulk-update',
	bulkReplaceAccessories: base_url + 'aed/parts/bulk-replace',
	// AED replacement links (ticket 10468965097)
	aedReplacementView: base_url + 'aed/device-replacement/view',
	aedReplacementCandidates: base_url + 'aed/device-replacement/candidates',
	aedReplacementLink: base_url + 'aed/device-replacement/link',
	aedReplacementUnlink: base_url + 'aed/device-replacement/unlink',
	aedReplacementBulkPreview: base_url + 'aed/device-replacement/bulk-preview',
	aedReplacementBulkApply: base_url + 'aed/device-replacement/bulk-apply',
	getAedsBySerialNumbersForParts: base_url + 'aed/parts/get-by-serial-numbers',
	getDependency: base_url + 'aed/add-aed-dependency',
	getDigestSettings: base_url + 'company/digest-settings/',
	updateDigestSettings: base_url + 'company/update-digest-settings',
	getResellerSites: base_url + 'reseller/get-sites',
	bulkUploadUsers: base_url + 'user/bulk-upload',
	bulkUpdateUsers: base_url + 'user/bulk-update',
	sendUserWelcomeEmail: base_url + 'user/send-welcome-email',
	getResellerSiteAccess: base_url + 'reseller/get-site-access',
	saveResellerSiteAccess: base_url + 'reseller/save-site-access',
	uploadCompanyBulkFile: base_url + 'company/bulk-upload',
	downloadCompanySampleFile: base_url + 'company/sample-file',
	getCompanyBulkColumns: base_url + 'company/bulk-columns',
	getCompanyBulkAllRows: base_url + 'company/bulk-all-rows',
	processCompanyBulkUpload: base_url + 'company/process-bulk-upload',
	previewAedData: base_url + 'company/preview-aed-data',
	getAedMasterData: base_url + 'company/aed-master-data',
	updateAedPreview: base_url + 'company/update-aed-preview',
	finalizeBulkUpload: base_url + 'company/finalize-bulk-upload',
	getCompanyData: base_url + 'company/view',
	getCompanyDetail: base_url + 'company/view-detail',
	companyPlans: base_url + 'company/plans/',
	getUserStatus: base_url + 'user/status',
	getUserEmailLogs: base_url + 'user/email-logs',
	getAllUserErrors: base_url + 'user/all-errors',
	getAllFailedLogins: base_url + 'user/failed-logins',
	addUserCertification: base_url + 'user/certification/add',
	updateUserCertification: base_url + 'user/certification/update',
	deleteUserCertification: base_url + 'user/certification/delete',
	listUserCertifications: base_url + 'user/certification/list',
	getUserSiteAedAccess: base_url + 'user/site-access/get',
	updateUserSiteAccess: base_url + 'user/site-access/update-sites',
	updateUserAedAccess: base_url + 'user/site-access/update-aeds',
	updateUserGlobalInspector: base_url + 'user/site-access/update-global-inspector',
	removeUserInspectorAssignments: base_url + 'user/site-access/remove-inspector-assignments',
	userCheckEmail: base_url + 'user/check-email',
	userCompaniesList: base_url + 'user/companies/list',
	userCompaniesAdd: base_url + 'user/companies/add',
	userCompaniesUpdate: base_url + 'user/companies/update',
	userCompaniesRemove: base_url + 'user/companies/remove',
	expiringSubscriptionsData: base_url + 'reseller-subscription/expiring-report-data',
	expiringSubscriptionsReport: base_url + 'reseller-subscription/expiring-report',
	syncAedToPulsePoint: base_url + 'aed/sync-to-pulsepoint',
	auditLogList: base_url + 'audit-log/list',
	expiringResellers: base_url + 'reseller-subscription/expiring-resellers',
	dateMismatchReport: base_url + 'reseller-subscription/date-mismatch-report',
	fixDateMismatch: base_url + 'reseller-subscription/fix-date-mismatch',
	getAedEventHistory: base_url + 'aed/event-history',
	reportBuilderDataSources: base_url + 'report-builder/data-sources',
	reportBuilderColumns: base_url + 'report-builder/columns',
	reportBuilderGenerate: base_url + 'report-builder/generate',
	reportBuilderFilterOptions: base_url + 'report-builder/filter-options',
	reportBuilderExport: base_url + 'report-builder/export',
	reportBuilderSavedList: base_url + 'report-builder/saved',
	reportBuilderSavedSave: base_url + 'report-builder/saved',
	reportBuilderSavedLoad: base_url + 'report-builder/saved/',
	reportBuilderSavedDelete: base_url + 'report-builder/saved/',
	ssoSetupToken: base_url + 'company/sso-setup-token',
	companyStatistics: base_url + 'company/statistics',
	companySiteAeds: base_url + 'company/site-aeds',
	companyAeds: base_url + 'company/aeds',
	rxAuditList: base_url + 'aed/rx-audit/list',
	rxAuditSummary: base_url + 'aed/rx-audit/summary',
	rxAuditRegenerate: base_url + 'aed/rx-audit/regenerate',
	rxAuditBulkRegenerate: base_url + 'aed/rx-audit/bulk-regenerate',
	rxAuditRegenerateAllMissing: base_url + 'aed/rx-audit/regenerate-all-missing',
	removedCompanyAeds: base_url + 'dashboard/removed-company-aeds',
	accountStats: base_url + 'dashboard/account-stats',
	accountStatsExport: base_url + 'dashboard/account-stats/export',
	accountStatsCompaniesByState: base_url + 'dashboard/account-stats/companies-by-state',
	accountStatsCompaniesByStateExport: base_url + 'dashboard/account-stats/companies-by-state/export',
	gpsTrackerList: base_url + 'gps-tracker/list',
	gpsTrackerAdd: base_url + 'gps-tracker/add',
	gpsTrackerUpdate: base_url + 'gps-tracker/update',
	gpsTrackerArchive: base_url + 'gps-tracker/archive',
	gpsTrackerRestore: base_url + 'gps-tracker/restore',
	gpsTrackerAssign: base_url + 'gps-tracker/assign',
	gpsTrackerUnassign: base_url + 'gps-tracker/unassign',
	gpsTrackerLocations: base_url + 'gps-tracker/locations',
	gpsTrackerUnassignedList: base_url + 'gps-tracker/unassigned-list',
	gpsTrackerReconcileSerials: base_url + 'gps-tracker/reconcile-serials',
	gpsTrackerOemInventory: base_url + 'gps-tracker/oem-inventory',
	gpsTrackerFleet: base_url + 'gps-tracker/fleet',
	gpsTrackerAssignBySerial: base_url + 'gps-tracker/assign-by-serial',
	gpsTrackerLocationSummary: base_url + 'gps-tracker/location-summary',
	gpsTrackerMapDevices: base_url + 'gps-tracker/map-devices',
	gpsTrackerMapAll: base_url + 'gps-tracker/map-all',
	gpsTrackerMapHistory: base_url + 'gps-tracker/map-history',
	gpsTrackerExportHistory: base_url + 'gps-tracker/export-history',
	gpsTrackerProfiles: base_url + 'gps-tracker/profiles',
	gpsTrackerGetProfile: base_url + 'gps-tracker/get-profile',
	gpsTrackerSetProfile: base_url + 'gps-tracker/set-profile',
	gpsTrackerBulkSetProfile: base_url + 'gps-tracker/bulk-set-profile',
	gpsTrackerPreviewProfile: base_url + 'gps-tracker/preview-profile',
	gpsTrackerTimezones: base_url + 'gps-tracker/timezones',
	gpsTrackerSetTimezone: base_url + 'gps-tracker/set-timezone',
	gpsTrackerRecoveryMode: base_url + 'gps-tracker/recovery-mode',
	gpsTrackerRecoveryStatus: base_url + 'gps-tracker/recovery-status',
	gpsTrackerSyncOem: base_url + 'gps-tracker/sync-oem',
	gpsTrackerLinkOem: base_url + 'gps-tracker/link-oem',
	zollBatteryReport: base_url + 'zoll/battery-report',
	zollBatteryReportExport: base_url + 'zoll/battery-report/export',
	zollBatteryReportAcknowledge: base_url + 'zoll/battery-report/acknowledge',
	zollBatteryReportUnacknowledge: base_url + 'zoll/battery-report/unacknowledge',
	disposablesReport: base_url + 'report/disposables',
	disposablesReportExport: base_url + 'report/disposables/export',
	disposablesReportFilters: base_url + 'report/disposables/filter-options',
	disposablesReuploadPreview: base_url + 'report/disposables/reupload/preview',
	disposablesReuploadCommit: base_url + 'report/disposables/reupload/commit',
	aedLocationsReportCustomers: base_url + 'report/aed-locations/customers',
	aedLocationsReportSites: base_url + 'report/aed-locations/sites',
	aedLocationsReportExport: base_url + 'report/aed-locations/export',
	tagBatteryReport: base_url + 'gps-tracker/battery-report',
	tagBatteryReportExport: base_url + 'gps-tracker/battery-report/export',
	zollSyncReports: base_url + 'zoll/sync-reports',
	zollSyncStart: base_url + 'zoll/sync-start',
	zollSyncLogs: base_url + 'zoll/sync-logs',
	zollSyncLogsClear: base_url + 'zoll/sync-logs/clear',
	syncCompaniesSearch: base_url + 'sync/companies/search',
	syncExport: base_url + 'sync/export',
	syncImport: base_url + 'sync/import',
	syncImportStatus: base_url + 'sync/import/status/',
	syncImportReport: base_url + 'sync/import/report/',
	emailTemplateCatalog: base_url + 'email-templates/catalog',
	emailTemplateGet: base_url + 'email-templates/get',
	emailTemplateSave: base_url + 'email-templates/save',
	emailTemplateDelete: base_url + 'email-templates/delete',
	emailTemplateVersions: base_url + 'email-templates/versions',
	emailTemplateRestore: base_url + 'email-templates/restore',
	emailTemplateSendSetting: base_url + 'email-templates/send-setting',
	verifyEmailBypass: base_url + 'user/verify-email',
	resendVerificationEmail: base_url + 'user/resend-verification-email',
	movementProfileSave: base_url + 'movement-profile/save',
	movementProfileGet: base_url + 'movement-profile/get',
	movementProfileToggle: base_url + 'movement-profile/toggle',
	movementProfileSetReference: base_url + 'movement-profile/set-reference',
	movementProfileAlerts: base_url + 'movement-profile/alerts',
	movementProfileCopy: base_url + 'movement-profile/copy',
	movementProfileEligibleTargets: base_url + 'movement-profile/eligible-targets',
	movementProfileRecipientOptions: base_url + 'movement-profile/recipient-options',
	movementProfileDelete: base_url + 'movement-profile/delete',
	siteStatistics: base_url + 'site/statistics',
	sqlConsoleExecute: base_url + 'sql-console/execute',
	sqlConsoleTables: base_url + 'sql-console/tables',
	staffList: base_url + 'staff/list',
	staffAdd: base_url + 'staff/add',
	staffView: base_url + 'staff/view',
	staffUpdate: base_url + 'staff/update',
	staffDelete: base_url + 'staff/delete',
	staffDropdown: base_url + 'staff/dropdown',
	staffAssign: base_url + 'staff/assign',
	staffUnassign: base_url + 'staff/unassign',
	staffAssignments: base_url + 'staff/assignments',
	staffBulkAssignByState: base_url + 'staff/bulk-assign-by-state',
	staffTransfer: base_url + 'staff/transfer',
	staffExportAssignments: base_url + 'staff/export-assignments',
	staffCompanyAssignments: base_url + 'staff/company-assignments',
	staffCreateLogin: base_url + 'staff/create-login',
	staffSendInvite: base_url + 'staff/send-invite',
	staffViewAs: base_url + 'staff/view-as',
	territoryList: base_url + 'territory/list',
	territoryAdd: base_url + 'territory/add',
	territoryUpdate: base_url + 'territory/update',
	territoryDelete: base_url + 'territory/delete',
	demoMonthlyInspection: base_url + 'dev-tools/demo-monthly-inspection',
	statusRulesList: base_url + 'status-rules/list',
	statusRulesCreate: base_url + 'status-rules/create',
	statusRulesUpdate: base_url + 'status-rules/update/',
	statusRulesDelete: base_url + 'status-rules/delete/',
	statusRulesFlow: base_url + 'status-rules/flow/',
	statusRulesPreview: base_url + 'status-rules/preview',
	statusRulesAudit: base_url + 'status-rules/audit',
	statusRulesProcessingLog: base_url + 'status-rules/processing-log',
	aedAuditSummary: base_url + 'aed-audit/summary',
	aedAuditDetail: base_url + 'aed-audit/detail',
	aedAuditSitesForAed: base_url + 'aed-audit/sites-for-aed',
	aedAuditAssignSite: base_url + 'aed-audit/assign-site',
	digestQueuePending: base_url + 'digest-queue/pending',
	digestQueueRecent: base_url + 'digest-queue/recent',
	digestQueueFailed: base_url + 'digest-queue/failed',
	digestQueueCompanyStatus: base_url + 'digest-queue/company-status',
	zollAed3Status: base_url + 'zoll/aed3-status'
	};
